import { Button, Card, Flex, Spin, Typography } from "antd";

const { Title, Paragraph, Text } = Typography;

/** 未認証のときの画面。通常は自動で Keycloak に飛ぶので一瞬だけ見える。 */
export function Login({ error, onLogin }: { error?: string; onLogin: () => void }) {
  return (
    <Flex align="center" justify="center" style={{ minHeight: "100vh" }}>
      <Card style={{ width: 420, textAlign: "center" }}>
        <Title level={3} style={{ marginTop: 0 }}>
          統合IT管理基盤
        </Title>
        {error ? (
          <>
            <Paragraph type="danger">ログインに失敗した</Paragraph>
            <Paragraph>
              <Text code>{error}</Text>
            </Paragraph>
            <Button type="primary" onClick={onLogin}>
              もう一度ログインする
            </Button>
          </>
        ) : (
          <>
            <Paragraph type="secondary">ログイン画面へ移動しています…</Paragraph>
            <Spin />
            <Paragraph style={{ marginTop: 24, marginBottom: 0 }}>
              <Button onClick={onLogin}>移動しない場合はここをクリック</Button>
            </Paragraph>
          </>
        )}
      </Card>
    </Flex>
  );
}
